import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'nav_pinned_paths';
const EVENT_NAME = 'nav-pins-changed';

function getStored() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
}

export default function useNavPins() {
  const [pinnedPaths, setPinnedPaths] = useState(getStored);

  // Subscribe to changes from any other useNavPins instance
  useEffect(() => {
    const handler = () => setPinnedPaths(getStored());
    window.addEventListener(EVENT_NAME, handler);
    return () => window.removeEventListener(EVENT_NAME, handler);
  }, []);

  const togglePin = useCallback((path) => {
    setPinnedPaths((prev) => {
      const next = prev.includes(path)
        ? prev.filter((p) => p !== path)
        : [...prev, path];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      // Notify all other hook instances in the tree
      window.dispatchEvent(new Event(EVENT_NAME));
      return next;
    });
  }, []);

  const isPinned = useCallback((path) => pinnedPaths.includes(path), [pinnedPaths]);

  return { pinnedPaths, togglePin, isPinned };
}
